/*
 * GroupDetails Messages
 *
 * This contains all the text for the GroupDetails component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.GroupDetails';

export default defineMessages({
  membersTotal: {
    id: `${scope}.membersTotal`,
    defaultMessage: 'members total',
  },
  createAccessCode: {
    id: `${scope}.createAccessCode`,
    defaultMessage: 'Create Access Code',
  },
  sendQuestion: {
    id: `${scope}.sendQuestion`,
    defaultMessage: 'Send Questionnaire',
  },
  fName: {
    id: `${scope}.fName`,
    defaultMessage: 'First Name',
  },
  lName: {
    id: `${scope}.lName`,
    defaultMessage: 'Last Name',
  },
  sex: {
    id: `${scope}.sex`,
    defaultMessage: 'Sex',
  },
  birth: {
    id: `${scope}.birth`,
    defaultMessage: 'Birth',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
  addMembers: {
    id: `${scope}.addMembers`,
    defaultMessage: 'Add members to group',
  },
});
